import { Grid } from "@mui/material";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";
import { RateAgreementBase } from "./RateAgreementBase";
import { RateAgreementDetails } from "./RateAgreementDetails";

export const RateAgreementInformationForm = ({
  disabledFields,
}: MdmFormProps) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <RateAgreementBase disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={9}>
        <RateAgreementDetails disabledFields={disabledFields} />
      </Grid>
    </Grid>
  );
};
